// Normalize image URLs so they work on whatever domain we're on
// (preview, mysteryserved.com, custom domains, etc.).
//
// If a URL was saved with a hardcoded host (e.g.
// "https://mystery-checkout-hub.preview.emergentagent.com/api/files/...") we strip
// the host so the browser resolves it against the CURRENT origin.
// Everything else (data URIs, external URLs) is returned unchanged.
export function normalizeImageUrl(url) {
  if (!url || typeof url !== "string") return url;
  // Already relative or a data URI — leave it alone.
  if (url.startsWith("/") || url.startsWith("data:")) return url;
  // If it contains /api/files/, strip everything before that path.
  const idx = url.indexOf("/api/files/");
  if (idx > -1) return url.slice(idx);
  return url;
}
